/**
 * Hero Slider Frontend JavaScript
 * Custom slider implementation without external dependencies
 * Includes dynamic H1 management for SEO compliance
 */

document.addEventListener("DOMContentLoaded", function () {
	const sliders = document.querySelectorAll(".gutenberg-hero-slider");

	sliders.forEach(function (slider) {
		initSlider(slider);
	});
});

function initSlider(slider) {
	const slides = slider.querySelectorAll(".gutenberg-hero-slider__card-wrap");
	const showDots = slider.dataset.dots === "true";
	const autoplay = slider.dataset.autoplay === "true";
	const speed = parseInt(slider.dataset.speed) || 300;
	const autoplaySpeed = parseInt(slider.dataset.autoplayspeed) || 5000;

	let currentSlide = 0;
	let autoplayInterval = null;
	let isTransitioning = false;
	let dotsContainer = null;

	slider.querySelectorAll(".gutenberg-hero-slider__read-more").forEach((button) => {
		button.addEventListener("click", showReadMoreText);
	});


	// If only one slide, don't initialize slider
	if (slides.length <= 1) {
		return;
	}

	// Set up initial state - show first slide, hide others
	slides.forEach((slide, index) => {
		if (index === 0) {
			slide.classList.add("slick-active");
		}
		// Don't set positioning here - let CSS handle it based on slider state
	});

	// Initial heading tag update
	updateHeadingTags(0);

	// Make sure slider container has relative positioning
	slider.style.position = "relative";

	function buildDots(container) {
		// Preserve existing classes
		container.classList.add("slick-dots");

		// Build buttons
		slides.forEach((_, i) => {
			const btn = document.createElement("button");
			btn.type = "button";
			btn.dataset.index = i;
			btn.setAttribute("aria-label", `Go to slide ${i + 1}`);
			if (i === 0) btn.classList.add("slick-active");
			container.appendChild(btn);
		});

		// Event delegation
		container.addEventListener("click", (e) => {
			const btn = e.target.closest("button");
			if (!btn) return;
			const idx = Number(btn.dataset.index);
			if (!Number.isNaN(idx)) goToSlide(idx);
		});
	}

	function syncActiveDots(currentIndex) {
		slider
			.querySelectorAll(".slick-dots button, .slick-dots-mobile button")
			.forEach((btn) => {
				const idx = Number(btn.dataset.index);
				btn.classList.toggle("slick-active", idx === currentIndex);
			});
	}

	if (showDots) {
		// Desktop dots (one set)
		const dotsContainer = document.createElement("div");
		buildDots(dotsContainer);
		slider.appendChild(dotsContainer);

		// Mobile dots (one set per slide)
		const mobileTextEls = slider.querySelectorAll(".gutenberg-hero-slider__mobile-text");
		mobileTextEls.forEach((el) => {
			const mobileDots = document.createElement("div");
			mobileDots.classList.add("slick-dots-mobile"); // add mobile class first
			buildDots(mobileDots); // then add 'slick-dots' (preserved)
			el.appendChild(mobileDots);
		});

		slider.classList.add("slick-dotted");
	}


	// Create navigation arrows (hidden on mobile via CSS)
	const prevArrow = document.createElement("button");
	prevArrow.className = "slick-prev slick-arrow";
	prevArrow.setAttribute("aria-label", "Previous slide");
	prevArrow.innerHTML = "‹";
	prevArrow.addEventListener("click", prevSlide);

	const nextArrow = document.createElement("button");
	nextArrow.className = "slick-next slick-arrow";
	nextArrow.setAttribute("aria-label", "Next slide");
	nextArrow.innerHTML = "›";
	nextArrow.addEventListener("click", nextSlide);

	slider.appendChild(prevArrow);
	slider.appendChild(nextArrow);

	// Start autoplay if enabled
	if (autoplay) {
		startAutoplay();

		// Pause on hover
		slider.addEventListener("mouseenter", stopAutoplay);
		slider.addEventListener("mouseleave", startAutoplay);
	}

	// Touch/swipe support for mobile
	let startX = null;
	let currentX = null;
	let startY = null;
	let currentY = null;

	slider.addEventListener("touchstart", handleTouchStart, { passive: true });
	slider.addEventListener("touchmove", handleTouchMove, { passive: false });
	slider.addEventListener("touchend", handleTouchEnd, { passive: true });

	function handleTouchStart(e) {
		startX = e.touches[0].clientX;
		startY = e.touches[0].clientY;
	}

	function handleTouchMove(e) {
		if (!startX || !startY) return;

		currentX = e.touches[0].clientX;
		currentY = e.touches[0].clientY;

		const diffX = Math.abs(startX - currentX);
		const diffY = Math.abs(startY - currentY);

		// If horizontal swipe is more significant than vertical, prevent default scrolling
		if (diffX > diffY && diffX > 10) {
			e.preventDefault();
		}
	}

	function handleTouchEnd(e) {
		if (!startX || !currentX || !startY || !currentY) return;

		const diffX = startX - currentX;
		const diffY = startY - currentY;
		const threshold = 50; // Minimum swipe distance

		// Only trigger slide change if horizontal movement is greater than vertical
		if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
			if (diffX > 0) {
				nextSlide(); // Swipe left - go to next
			} else {
				prevSlide(); // Swipe right - go to previous
			}
		}

		startX = null;
		currentX = null;
		startY = null;
		currentY = null;
	}

	function updateHeadingTags(newSlideIndex) {
		// Update all slide headings to ensure only the active slide has H1
		slides.forEach((slide, index) => {
			const titles = slide.querySelectorAll("[data-dynamic-heading]");

			titles.forEach((title) => {
				const currentTag = title.tagName.toLowerCase();
				const shouldBeH1 = index === newSlideIndex;

				// Get the intended heading from the slide container's data attribute
				const intendedHeading = slide.dataset.intendedHeading || "h2";
				const targetTag = shouldBeH1 ? "h1" : intendedHeading;

				// Only update if the tag needs to change
				if (currentTag !== targetTag) {
					const newElement = document.createElement(targetTag);

					// Copy all attributes
					Array.from(title.attributes).forEach((attr) => {
						newElement.setAttribute(attr.name, attr.value);
					});

					// Copy content and classes
					newElement.innerHTML = title.innerHTML;

					// Replace the element
					title.parentNode.replaceChild(newElement, title);
				}
			});
		});
	}

	function goToSlide(index) {
		if (
			isTransitioning ||
			index === currentSlide ||
			index < 0 ||
			index >= slides.length
		) {
			return;
		}

		isTransitioning = true;

		const currentSlideElement = slides[currentSlide];
		const newSlideElement = slides[index];

		// Check if this is an auto-height slider
		const isAutoHeight = slider.closest(".hero--auto-height") !== null;

		// Update heading tags before transition
		updateHeadingTags(index);

		if (isAutoHeight) {
			// For auto-height sliders, use display switching
			currentSlideElement.classList.remove("slick-active");
			currentSlideElement.style.display = "none";

			newSlideElement.style.display = "block";
			newSlideElement.classList.add("slick-active");

			currentSlide = index;
			isTransitioning = false;
			updateDots();
			syncActiveDots(index);
		} else {
			// For fixed-height sliders, use opacity transitions
			currentSlideElement.style.transition = `opacity ${speed}ms ease`;
			newSlideElement.style.transition = `opacity ${speed}ms ease`;

			// Position new slide and start fade in
			newSlideElement.style.zIndex = "3";
			newSlideElement.style.opacity = "0";

			// Force reflow
			newSlideElement.offsetHeight;

			// Start transitions
			currentSlideElement.style.opacity = "0";
			newSlideElement.style.opacity = "1";

			// Update active classes
			currentSlideElement.classList.remove("slick-active");
			newSlideElement.classList.add("slick-active");

			setTimeout(() => {
				// Clean up after transition
				currentSlideElement.style.zIndex = "1";
				currentSlideElement.style.transition = "none";

				newSlideElement.style.zIndex = "2";
				newSlideElement.style.transition = "none";

				currentSlide = index;
				isTransitioning = false;

				updateDots();
				syncActiveDots(index);
			}, speed);
		}
	}

	function nextSlide() {
		const nextIndex = (currentSlide + 1) % slides.length;
		goToSlide(nextIndex);
	}

	function prevSlide() {
		const prevIndex = (currentSlide - 1 + slides.length) % slides.length;
		goToSlide(prevIndex);
	}

	function updateDots() {
		if (!dotsContainer) return;

		const dots = dotsContainer.querySelectorAll("button");
		dots.forEach((dot, index) => {
			if (index === currentSlide) {
				dot.classList.add("slick-active");
			} else {
				dot.classList.remove("slick-active");
			}
		});
	}

	function startAutoplay() {
		if (!autoplay || autoplayInterval) return;
		autoplayInterval = setInterval(nextSlide, autoplaySpeed);
	}

	function stopAutoplay() {
		if (autoplayInterval) {
			clearInterval(autoplayInterval);
			autoplayInterval = null;
		}
	}

	function showReadMoreText(e) {
		const readMoreButton = e.currentTarget;
		const hiddenText = readMoreButton.nextElementSibling;
		if (hiddenText) {
			hiddenText.style.display = "block";
			readMoreButton.style.display = "none";
		}
	}

	// Keyboard navigation
	slider.addEventListener("keydown", function (e) {
		if (e.key === "ArrowLeft") {
			e.preventDefault();
			prevSlide();
		} else if (e.key === "ArrowRight") {
			e.preventDefault();
			nextSlide();
		}
	});

	// Make slider focusable for keyboard navigation
	slider.setAttribute("tabindex", "0");

	// Handle window resize to ensure slides stay positioned correctly
	window.addEventListener("resize", function () {
		slides.forEach((slide) => {
			slide.style.width = "100%";
		});
	});
}
